<template>
  <div id="page-content-wrapper" class="admin-content-area">
    <div class="container-fluid xyz">
        <div class="page-header-top-container">
            <div class="page-name">{{pageTitle}}</div>
        </div>
        <!--page content-->
        <div class="admin-page-content">
            <!--Forms-->
            <div class="forms-container add_user_forms_container">
                <div class="row no-margin">

                    <!--First Name-->
                    <div class="col-6 forms-block">

                    <template v-if="userName !== ''">
                      Connected with <h4> {{ userName }}</h4>
                      <!--p>Use the navigation bar at the top of the page to get started.</p-->
                    </template>
                    <template v-else>
                        <a href="" v-on:click.prevent="connectSharePoint" class="btn btn-primary btn-large">Click here to sign in</a>
                    </template>



                    </div>
                </div>


            </div>
            <!-- Forms -->
        </div>
        <!--page content-->
    </div>
    <app-footer></app-footer>
  </div>

</template>

<script>

  var self;
  import Vue from 'vue';
  // import vSelect from 'vue-select';
  import Footer from '@/components/partials/Footer';
  import {commonMixins} from '../mixins/commonMixins';
  import {HTTP} from '../http-common.js';
  import EventBus from "./event-bus";

export default {
  name: 'SharePoint',
  mixins: [commonMixins],
  components: {
      'app-footer': Footer,
      // 'v-select': vSelect,
  },
  data() {
    return {
        pageTitle : "SharePoint",
        userName: "",
    }
  },
  watch: {

  },
  mounted() {
    self = this;
    EventBus.$emit("menu-selection-changed", "sharepoint");
    self.getSigninDetails();
  },
  methods: {
    connectSharePoint:function() {
      console.log("connect Sharepoint");
      window.location =  process.env.ROOT_API + "/sharepoint/signin";
    },
    getSigninDetails: function () {
        var config = {
            headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
        };

        HTTP.post('/sharepoint/signin-detail', {}, config).
        then(response => {

            // response.data.user.first_name;
            console.log(response.data);
            self.userName = response.data.content.value.userName;

        })
            .catch(function (err) {
                console.log(err);
                if (err.response.status == 0) {
                    //self.error = "Remote server can not be reachable";
                } else {
                    //redirect to login page if user not authenticated
                    if (err.response.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("api_token");
                        //self.$router.push("/login");
                    }
                    //self.error = err.response.data.message;
                }
            });
    },

  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/SharePoint.vue